module.exports = __webpack_public_path__ + "img/1 (106).04e0250e.png";